import { useMemo } from 'react'

import { useQuery } from 'react-query'
import { useSelector } from 'react-redux'

import { makeSelectContentTypesByModel } from '@webapp/core/stores/global'
import { ReportAccessGrant } from '@webapp/platform/iam/entities/ReportAccessGrant'
import { reportAccessGrantQueryConfig } from '@webapp/platform/iam/query-configs/reportAccessGrant'

type UseQueryReportAccessGrantsReturn = {
  grants: ReportAccessGrant[]
  isLoading: boolean
  error: unknown
  refetch: () => void
}

export const useQueryReportAccessGrants = (
  secondaryCategoryId: number
): UseQueryReportAccessGrantsReturn => {
  const secondaryCategoryContentType = useSelector(
    makeSelectContentTypesByModel('procurify', 'department')
  )

  const { data, isLoading, error, refetch } = useQuery({
    ...reportAccessGrantQueryConfig.list({
      secondaryCategoryId,
      secondaryCategoryContentTypeId: secondaryCategoryContentType?.id,
    }),
  })

  const grants = useMemo(
    () => (data ?? []).map((grant) => new ReportAccessGrant(grant)),
    [data]
  )

  return {
    grants,
    isLoading,
    error,
    refetch,
  }
}
